import { App, Plugin } from "vue";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(utc);
dayjs.extend(relativeTime);

const plugin: Plugin = {
  install: (app: App) => {
    app.config.globalProperties.$date = (format: string, date: Date | string, localTime?: boolean) => {
      const parsed = localTime ? dayjs(date).utc(true).local() : dayjs(date);

      if (!parsed.isValid()) {
        return "";
      }

      return parsed.format(format);
    };
    app.config.globalProperties.$dateWithRelativeTime = (
      dateString: Date | string,
      localTime = false,
      noYear = false,
    ) => {
      // check if dateString is a valid date
      if (!dayjs(dateString).isValid()) {
        return "";
      }
      const date = localTime ? dayjs(dateString).utc(true).local() : dayjs(dateString);
      const now = localTime ? dayjs().local() : dayjs();

      if (date.isSame(now, "day")) {
        return date.fromNow(); // "2 hours ago", "a few minutes ago", etc.
      }
      if (date.isSame(now.subtract(1, "day"), "day")) {
        return `Yesterday at ${date.format("h:mma")}`;
      }
      if (noYear) {
        return date.format("MM/DD") + " at " + date.format("h:mma");
      }
      return date.format("MMMM D, YYYY") + " at " + date.format("h:mma");
    };
  },
};

export default plugin;
